import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { ChartColors, ChartOptions, ChartsConfig } from '../chart-option-modal';


declare global {
  interface Window {
    Apex: any;
  }
}

window.Apex = {
  chart: {
    toolbar: {
      show: false
    }
  },
  tooltip: {
    shared: false
  },
  legend: {
    show: false
  }
};


@Component({
  selector: 'app-dynamic-chart',
  templateUrl: './dynamic-chart.component.html',
  styleUrl: './dynamic-chart.component.scss'
})

export class DynamicChartComponent implements OnInit, OnChanges {
  @ViewChild('chart') chart!: ChartComponent;
  @Input() chartOptions!: Partial<ChartOptions>;
  @Input() chartQuarterOptions!: Partial<ChartOptions>;
  @Input() chartData: any;

  chartColors: any[] = ChartColors

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.chartData?.primaryChartSeriesData)
      this.getSaleTrend()
  }

  getSaleTrend() {
    this.chartOptions = {
      series: [
        {
          name: "Monthly",
          data: this.makeData()
        }
      ],
      chart: {
        id: "barYear",
        height: 400,
        width: "100%",
        type: "bar",
        events: {
          dataPointSelection: (e: any, chart: any, opts: any) => {
            var quarterChartEl = document.querySelector("#chart-quarter");
            var yearChartEl = document.querySelector("#chart-year");

            if (opts.selectedDataPoints[0].length === 1) {
              if (quarterChartEl?.classList.contains("active")) {
                this.updateSubChart(chart, "barQuarter");
              } else {
                yearChartEl?.classList.add("chart-quarter-activated");
                quarterChartEl?.classList.add("active");
                this.updateSubChart(chart, "barQuarter");
              }
            } else {
              this.updateSubChart(chart, "barQuarter");
            }

            if (opts.selectedDataPoints[0].length === 0) {
              yearChartEl?.classList.remove("chart-quarter-activated");
              quarterChartEl?.classList.remove("active");
            }
          },
          updated: (chart: any) => {
            this.updateSubChart(chart, "barQuarter");
          }
        }
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: true,
          barHeight: "75%",
          dataLabels: {
            position: "bottom"
          }
        }
      },
      dataLabels: {
        enabled: true,
        textAnchor: "middle",
        style: {
          colors: ["#fff"],
        },
        formatter: function (val: any, opt: any) {
          return opt.w.globals.labels[opt.dataPointIndex];
        },
        offsetX: 0,
        dropShadow: {
          enabled: true
        }
      },

      colors: this.chartColors,

      states: {
        hover: {
          filter: {
            type: "desaturate"
          }
        },
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: "darken",
            // value: 1
          }
        }
      },
      tooltip: {
        x: {
          show: false
        },
        y: {
          title: {

          }, formatter: function (val: any, opts: any) {
            return opts.w.globals.labels[opts.dataPointIndex];
          }
        }
      },
      title: {
        text: "Monthly Sale",
        offsetX: 15,
        style: {
          fontSize: ChartsConfig.TitleFontSize
        }
      },
      subtitle: {
        text: "(Click on bar to see details)",
        offsetX: 15
      },
      yaxis: {
        labels: {
          show: false
        }
      }
    };

    this.chartQuarterOptions = {
      series: [
        {
          name: "Week",
          data: []
        }
      ],
      chart: {
        id: "barQuarter",
        height: 400,
        width: "100%",
        type: "bar",
        stacked: true
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          horizontal: false
        }
      },
      legend: {
        show: false
      },
      grid: {
        yaxis: {
          lines: {
            show: false
          }
        },
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      title: {
        text: "Weekly Sale",
        offsetX: 10
      },
      tooltip: {
        x: {
          formatter: function (val: any, opts: any) {
            return opts.w.globals.seriesNames[opts.seriesIndex];
          }
        },
        y: {
          title: {

          }, formatter: function (val: any, opts: any) {
            return opts.w.globals.labels[opts.dataPointIndex];
          }

        }
      }
    };
  }

  public makeData(): any {
    let PrimaryGraphDataSeries: any[] = []
    let index = 0;
    this.chartData?.primaryChartSeriesData?.forEach((series: any) => {

      PrimaryGraphDataSeries.push({
        x: series.monthName + '(' + series.year + ')',
        y: series.monthTotalSale,
        color: this.chartColors[index++],
        weeks: series.weeks
      })
    });

    return PrimaryGraphDataSeries;
  }

  public updateSubChart(sourceChart: any, destChartIDToUpdate: any) {
    var series: any[] = [];
    var seriesIndex = 0;
    var colors = [];

    if (sourceChart.w.globals.selectedDataPoints[0]) {
      var selectedPoints = sourceChart.w.globals.selectedDataPoints;
      for (var i = 0; i < selectedPoints[seriesIndex].length; i++) {
        var selectedIndex = selectedPoints[seriesIndex][i];
        var yearSeries = sourceChart.w.config.series[seriesIndex];
        series.push({
          name: yearSeries.data[selectedIndex].x,
          data: yearSeries.data[selectedIndex].weeks
        });
        colors.push(yearSeries.data[selectedIndex].color);
      }

      if (series.length === 0)
        series = [
          {
            data: []
          }
        ];

      return window.ApexCharts.exec(destChartIDToUpdate, "updateOptions", {
        series: series,
        colors: colors,
        fill: {
          colors: colors
        }
      });
    }
  }
}



